// Page-level accumulators for product list tile interactions, folded into
// the page_exited event (see init.ts). Deliberately module-level with no
// reset, matching the lifetime semantics of the other page_exited
// aggregates (e.g. galleryInteractionsEnrichment): one browser page load =
// one accumulation window.

let maxInteractionIndex = 0
let sliderInteractions = 0
let variantInteractions = 0

// tileIndex is 1-based (1 through the block's tile count), per the plan
export const trackTileSliderInteraction = (tileIndex: number) => {
  sliderInteractions += 1
  maxInteractionIndex = Math.max(maxInteractionIndex, tileIndex)
}

export const trackTileVariantInteraction = (tileIndex: number) => {
  variantInteractions += 1
  maxInteractionIndex = Math.max(maxInteractionIndex, tileIndex)
}

export const getTileInteractionProperties = () => {
  if (sliderInteractions === 0 && variantInteractions === 0) {
    return {}
  }

  return {
    tile_max_interaction_index: maxInteractionIndex,
    tile_slider_interactions: sliderInteractions,
    tile_variant_interactions: variantInteractions,
  }
}
